const MaterialType = {
  STANDARD: "Standard",
  GLASS: "Glass",
  TRANSPARENT: "Transparent",
};

export { MaterialType };
